const values = {
  TWO: '2 mins read',
  FIVE: '5 mins read',
  TEN_PLUS: '>10 mins read',
};

export const LengthEnum = {
  TWO: 'TWO',
  FIVE: 'FIVE',
  TEN_PLUS: 'TEN_PLUS',
} as const;

export type LengthEnum = (typeof LengthEnum)[keyof typeof LengthEnum];

export const getLengthEnumTextByKey = (key) => {
  return values[key];
};
